var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1665 19.1895C22.1665 19.7199 21.9558 20.2286 21.5807 20.6037C21.2056 20.9787 20.6969 21.1895 20.1665 21.1895H4.1665C3.63607 21.1895 3.12736 20.9787 2.75229 20.6037C2.37722 20.2286 2.1665 19.7199 2.1665 19.1895V5.18945C2.1665 4.65902 2.37722 4.15031 2.75229 3.77524C3.12736 3.40017 3.63607 3.18945 4.1665 3.18945H9.1665L11.1665 6.18945H20.1665C20.6969 6.18945 21.2056 6.40017 21.5807 6.77524C21.9558 7.15031 22.1665 7.65902 22.1665 8.18945V19.1895Z",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.d1a564d27cb60eb308e63b9305e1f088.svg";
export { ForwardRef as ReactComponent };